const extractFileData = require("./extractFileData");

module.exports = function transformContactCardData(entity) {
	const { attributes, type, id } = entity;
	if (!attributes) return null;
	const relationships = entity && entity.relationships ? entity.relationships : null;
	const info = {
		id,
		type,
		address: {},
		cardType: "company",
		title: attributes.title,
	};
	if (attributes.field_phone) info.phone = attributes.field_phone;
	if (attributes.field_email) info.mail = attributes.field_email;
	if (attributes.field_to) {
		info.website = attributes.field_to.uri;
		if (attributes.field_to.title) {
			info.website_label = attributes.field_to.title;
		}
	}
	if (attributes.field_street_address)
		info.address.street = attributes.field_street_address;
	if (attributes.field_state) info.address.state = attributes.field_state;
	if (attributes.field_zipcode) info.address.zip = attributes.field_zipcode;
	if (relationships) {
		if (relationships.field_cities && relationships.field_cities.data) {
			let cities = Array.isArray(relationships.field_cities.data)
				? relationships.field_cities.data
				: [relationships.field_cities.data];
			let city_names = cities.map((city) => city.attributes.name);
			info.address.city = city_names.join(", ");
		}
		if (process.env.CLF_BACKEND_URL) {
			let picture_rel_data = null;
			const file_field_name = "field_media_image";

			let picture_field_name = [
				"field_image",
				"field_featured_image",
				"field_profile_image",
			].find(
				(pic_field_name) =>
					relationships[pic_field_name] && relationships[pic_field_name].data
			);

			if (picture_field_name) {
				picture_rel_data = relationships[picture_field_name].data;
			}
			if (picture_rel_data) {
				const picture_data = extractFileData(picture_rel_data, file_field_name);
				if (picture_data) {
					info.picture = picture_data;
				}
			}
		}
	}
	return info;
};
